import { render } from "./ProfilePassword.vue?vue&type=template&id=7603bb50&scoped=true"
import script from "./ProfilePassword.vue?vue&type=script&lang=js"
export * from "./ProfilePassword.vue?vue&type=script&lang=js"

import "./ProfilePassword.vue?vue&type=style&index=0&id=7603bb50&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7603bb50"]])

export default __exports__